import * as firebase from 'firebase';

const config = {
  authDomain: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  databaseURL: process.env.VUE_APP_FIREBASE_DB_URL,
  storageBucket: `${process.env.VUE_APP_FIREBASE_PROJECT_ID}.appspot.com`,
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY, // TODO: Production: Restric Api Key
};

firebase.initializeApp(config);

export default firebase;
